import React from "react";
// import { LuNotebookPen } from "react-icons/lu";
import { GoPeople } from "react-icons/go";
import { GrMoney } from "react-icons/gr";
import { IoBookOutline } from "react-icons/io5";
import { LiaChalkboardTeacherSolid } from "react-icons/lia";
import { LuSchool } from "react-icons/lu";
import { PiExam } from "react-icons/pi";

export default function CollapsibleDiv() {
  return (
    <section>
      {/* Desktop view */}
      <div className="hidden md:block">
        <section className="mx-32 h-60 grid lg:grid-cols-7 gap-5 ">
          <div
            tabIndex={0}
            className="collapse group hover:collapse-open hover:col-span-2 bg-base-100 border-base-300 border "
          >
            <div className="px-10 group-hover:px-0 text-white bg-sky-950 py-5 font-semibold flex justify-around  gap-2 relative">
              <div className="">
                <IoBookOutline className="text-4xl absolute" />
              </div>
              <div className="block w-44 group-hover:hidden -rotate-90 transition-transform duration-300">
                <p className="text-2xl">মানসম্মত শিক্ষা</p>
              </div>
              <div className="hidden group-hover:block">
                <p className="text-2xl">মানসম্মত শিক্ষা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                অভিজ্ঞ শিক্ষকবৃন্দের মাধ্যমে মানসম্মত সিলেবাস অনুযায়ী পড়ানো হয়,
                পাঠ্যবইয়ের সঙ্গে প্রয়োজনীয় নোট ও PDF সরবরাহ করা হয়।
              </p>
            </div>
          </div>
          <div
            tabIndex={1}
            className="collapse group hover:collapse-open hover:col-span-2 bg-base-100 border-base-300 border "
          >
            <div className="px-10 group-hover:px-0 text-white bg-emerald-500 py-5 font-semibold flex justify-around  gap-2 relative">
              <div className="">
                <PiExam className="text-4xl absolute" />
              </div>
              <div className="block w-44 group-hover:hidden -rotate-90 transition-transform duration-300">
                <p className="text-2xl">নিয়মিত পরীক্ষা</p>
              </div>
              <div className="hidden group-hover:block">
                <p className="text-2xl">নিয়মিত পরীক্ষা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                অনলাইনে প্রতিযোগিতামূলক পরীক্ষা নেওয়া হয় এবং রেজাল্টের উপর
                ফিডব্যাক দেওয়া হয়।
              </p>
            </div>
          </div>
          <div
            tabIndex={2}
            className="collapse group hover:collapse-open hover:col-span-2 bg-base-100 border-base-300 border "
          >
            <div className="px-10 group-hover:px-0 text-white bg-amber-400 py-5 font-semibold flex justify-around  gap-2 relative">
              <div className="">
                <LiaChalkboardTeacherSolid className="text-4xl absolute" />
              </div>
              <div className="block w-44 group-hover:hidden -rotate-90 transition-transform duration-300">
                <p className="text-2xl">দাওয়াহ প্রশিক্ষণ</p>
              </div>
              <div className="hidden group-hover:block">
                <p className="text-2xl">দাওয়াহ প্রশিক্ষণ</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                ব্যক্তিগতভাবে শেখার পাশাপাশি অন্যদের শেখানোর জন্য প্রয়োজনীয়
                দিকনির্দেশনা দেওয়া হয়।
              </p>
            </div>
          </div>
          <div
            tabIndex={3}
            className="collapse group hover:collapse-open hover:col-span-2 bg-base-100 border-base-300 border "
          >
            <div className="px-10 group-hover:px-0 text-white bg-sky-600 py-5 font-semibold flex justify-around  gap-2 relative">
              <div className="">
                <GoPeople className="text-3xl absolute" />
              </div>
              <div className="block w-44 group-hover:hidden -rotate-90 transition-transform duration-300">
                <p className="text-2xl">সমাজসেবা</p>
              </div>
              <div className="hidden group-hover:block">
                <p className="text-2xl">সমাজসেবা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                পরিবারিক ও সামাজিকভাবে দ্বীনি পরিবেশ তৈরির জন্য প্রয়জনীয় পদক্ষেপ
                নেওয়া হয়।
              </p>
            </div>
          </div>
          <div
            tabIndex={4}
            className="collapse group hover:collapse-open hover:col-span-2 bg-base-100 border-base-300 border "
          >
            <div className="px-10 group-hover:px-0 text-white bg-violet-800 py-5 font-semibold flex justify-around  gap-2 relative">
              <div className="">
                <LuSchool className="text-3xl absolute" />
              </div>
              <div className="block w-44 group-hover:hidden -rotate-90 transition-transform duration-300">
                <p className="text-2xl">নির্ভরযোগ্য প্রতিষ্ঠান</p>
              </div>
              <div className="hidden group-hover:block">
                <p className="text-2xl">নির্ভরযোগ্য প্রতিষ্ঠান</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                বিশ্বস্ত শায়খদের পরামর্শে দ্বীনি শিক্ষা ও দাওয়াহ কার্যক্রম
                পরিচালিত হয়।
              </p>
            </div>
          </div>
          <div
            tabIndex={5}
            className="collapse group hover:collapse-open hover:col-span-2 bg-base-100 border-base-300 border "
          >
            <div className="px-10 group-hover:px-0 text-white bg-orange-600 py-5 font-semibold flex justify-around  gap-2 relative">
              <div className="">
                <GrMoney className="text-3xl absolute" />
              </div>
              <div className="block w-44 group-hover:hidden -rotate-90 transition-transform duration-300">
                <p className="text-2xl">সাশ্রয়ী কোর্স ফী সুবিধা</p>
              </div>
              <div className="hidden group-hover:block">
                <p className="text-2xl">সাশ্রয়ী কোর্স ফী সুবিধা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                সাশ্রয়ী ফী’তে কোর্সে ভর্তির সুযোগ। নওমুসলিমদের জন্য বিনামূল্যে
                পড়ার সুবিধা এবং অস্বচ্ছলদের জন্য সীমিত স্কলারশিপ রয়েছে।
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Mobile view */}
      <div className="block md:hidden">
        <section className="px-5">
          <div tabIndex={0} className="collapse  collapse-arrow my-2">
            <div className=" text-white bg-sky-950 collapse-title font-semibold flex ">
              <div className="">
                <IoBookOutline className="text-3xl " />
              </div>

              <div className="ml-3">
                <p className="text-2xl">মানসম্মত শিক্ষা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                অভিজ্ঞ শিক্ষকবৃন্দের মাধ্যমে মানসম্মত সিলেবাস অনুযায়ী পড়ানো হয়,
                পাঠ্যবইয়ের পাশাপাশি প্রয়জনীয় নোট pdf হিসেবে দেওয়া হয়।
              </p>
            </div>
          </div>
          <div tabIndex={1} className="collapse  collapse-arrow my-2">
            <div className=" text-white bg-emerald-500 collapse-title font-semibold flex ">
              <div className="">
                <PiExam className="text-3xl " />
              </div>

              <div className="ml-3">
                <p className="text-2xl">নিয়মিত পরীক্ষা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                অনলাইনে প্রতিযোগিতামূলক পরীক্ষা নেওয়া হয় এবং রেজাল্টের উপর
                ফিডব্যাক দেওয়া হয়।
              </p>
            </div>
          </div>
          <div tabIndex={2} className="collapse  collapse-arrow my-2">
            <div className=" text-white bg-amber-400 collapse-title font-semibold flex ">
              <div className="">
                <LiaChalkboardTeacherSolid className="text-3xl " />
              </div>

              <div className="ml-3">
                <p className="text-2xl">দাওয়াহ প্রশিক্ষণ</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                ব্যক্তিগতভাবে শেখার পাশাপাশি অন্যদের শেখানোর জন্য প্রয়োজনীয়
                দিকনির্দেশনা দেওয়া হয়।
              </p>
            </div>
          </div>
          <div tabIndex={3} className="collapse  collapse-arrow my-2">
            <div className=" text-white bg-sky-600 collapse-title font-semibold flex ">
              <div className="">
                <GoPeople className="text-3xl " />
              </div>

              <div className="ml-3">
                <p className="text-2xl">সমাজসেবা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                পরিবারিক ও সামাজিকভাবে দ্বীনি পরিবেশ তৈরির জন্য প্রয়জনীয় পদক্ষেপ
                নেওয়া হয়।
              </p>
            </div>
          </div>
          <div tabIndex={4} className="collapse  collapse-arrow my-2">
            <div className=" text-white bg-violet-800 collapse-title font-semibold flex ">
              <div className="">
                <LuSchool className="text-3xl " />
              </div>

              <div className="ml-3">
                <p className="text-2xl">নির্ভরযোগ্য প্রতিষ্ঠান</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                বিশ্বস্ত শায়খদের পরামর্শে দ্বীনি শিক্ষা ও দাওয়াহ কার্যক্রম
                পরিচালিত হয়।
              </p>
            </div>
          </div>
          <div tabIndex={5} className="collapse  collapse-arrow my-2">
            <div className=" text-white bg-orange-600 collapse-title font-semibold flex ">
              <div className="">
                <GrMoney className="text-3xl " />
              </div>

              <div className="ml-3">
                <p className="text-2xl">সাশ্রয়ী কোর্স ফী সুবিধা</p>
              </div>
              {/* <span className="group-hover:opacity-100 opacity-0 ">File 1</span> */}
            </div>

            <div className="collapse-content ">
              <p className="my-2">
                সাশ্রয়ী ফী’তে কোর্সে ভর্তির সুযোগ। নওমুসলিমদের জন্য বিনামূল্যে
                পড়ার সুবিধা এবং অস্বচ্ছলদের জন্য সীমিত স্কলারশিপ রয়েছে।
              </p>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}
